import React from 'react';
import styled from 'styled-components';

const LogoImage = styled.img.attrs({
  className: 'football-club-logo'
})`
  height: 40px;
  width: auto;
  vertical-align: middle;
  flex-grow: 1;
  
  @media (max-width: 768px) {
    height: 32px;
  }
  
  @media (max-width: 480px) {
    height: 28px;
  }
`;

interface FootballClubLogoProps {
  className?: string;
}

const FootballClubLogo: React.FC<FootballClubLogoProps> = ({ className }) => {
  return (
    <LogoImage 
      src="/logos/football-club-logo.png" 
      alt="Football Club" 
      className={className}
    />
  );
};

export default FootballClubLogo;